var map = {
	"./CanvasClear": 858,
	"./CanvasClear.ts": 858,
	"./CanvasMove": 884,
	"./CanvasMove.ts": 884,
	"./CommandAbstract": 790,
	"./CommandAbstract.ts": 790,
	"./ComponentDelete": 180,
	"./ComponentDelete.ts": 180,
	"./ComponentDrag": 544,
	"./ComponentDrag.ts": 544,
	"./ComponentEnter": 236,
	"./ComponentEnter.ts": 236,
	"./ComponentExit": 368,
	"./ComponentExit.ts": 368,
	"./ComponentNext": 243,
	"./ComponentNext.ts": 243,
	"./ComponentPrev": 400,
	"./ComponentPrev.ts": 400,
	"./ComponentStyleClear": 910,
	"./ComponentStyleClear.ts": 910,
	"./CopyComponent": 744,
	"./CopyComponent.ts": 744,
	"./DeleteComponent": 517,
	"./DeleteComponent.ts": 517,
	"./ExportTemplate": 457,
	"./ExportTemplate.ts": 457,
	"./Fullscreen": 975,
	"./Fullscreen.ts": 975,
	"./MoveComponent": 191,
	"./MoveComponent.ts": 191,
	"./OpenAssets": 912,
	"./OpenAssets.ts": 912,
	"./OpenBlocks": 117,
	"./OpenBlocks.ts": 117,
	"./OpenLayers": 614,
	"./OpenLayers.ts": 614,
	"./OpenStyleManager": 801,
	"./OpenStyleManager.ts": 801,
	"./OpenTraitManager": 395,
	"./OpenTraitManager.ts": 395,
	"./PasteComponent": 98,
	"./PasteComponent.ts": 98,
	"./Preview": 129,
	"./Preview.ts": 129,
	"./Resize": 116,
	"./Resize.ts": 116,
	"./SelectComponent": 407,
	"./SelectComponent.ts": 407,
	"./SelectPosition": 189,
	"./SelectPosition.ts": 189,
	"./ShowOffset": 804,
	"./ShowOffset.ts": 804,
	"./SwitchVisibility": 434,
	"./SwitchVisibility.ts": 434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 828;